// @flow
import React from 'react';

import type { ILayoutEnum } from '../layout';

import userLoginIcon from '../../../../assets/images/icons/user-login.svg';

import './style.pcss';

type Props = {|
  text: string,
  picture?: string,
  layout: ILayoutEnum
|};

const LoggedUser = ({
  picture,
  text,
  layout
}: Props) => (
  <div className='header-logged-user'>
    {picture ? (
      <img
        className='header-logged-user__photo'
        alt='user_photo'
        hidden=''
        src={picture}
      />
    ) : (
      <div
        className='login-button__icon'
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: userLoginIcon }}
      />
    )}
    <div className='header-logged-user__info'>
      <div className={`header-logged-user__text header-logged-user__text--${layout}`}>
        {text}
      </div>
    </div>
  </div>
);

export default LoggedUser;
